module.exports = __webpack_public_path__ + "static/media/slack-01.b725a3f0.svg";